import { GroupChips } from './group-chips.component';
import { GroupsTable } from './groups-table.component';
import { ViewAll } from './view-all.component';

const GROUP_CHIPS_LIMIT = 5;
const TABLE_STYLE = {
  minHeight: '30vh',
  maxHeight: '70vh',
  overflow: 'auto',
};

export const GroupChipsOrViewAll = ({
  label,
  description,
  ids,
  limit = GROUP_CHIPS_LIMIT,
}: {
  label: string;
  description: string;
  ids: string[];
  limit?: number;
}) => {
  return ids.length > limit ? (
    <ViewAll
      label={label}
      description={description}
      count={ids.length}
      renderContent={(show) => (
        <GroupsTable
          groupIds={ids}
          title={label}
          onClose={() => show(false)}
          tableSx={TABLE_STYLE}
        />
      )}
    />
  ) : (
    <GroupChips groupIds={ids} label={label} />
  );
};
